import React, { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { getName } from '@/utils';
import CustomSkinHelper from '@/pages/product/components/CustomSkin/helper';
import styles from './index.module.less';

const CustomSkinItem = inject(
  'area',
  'order'
)(
  observer(({ order, item }) => {
    let imageList = [];

    imageList = CustomSkinHelper.handleCustomCache({
      customType: item.customType,
      action: 'getAddToCart',
    });

    const { name, commodity, count } = item;
    const hasSameName = getName(name, 'split') === getName(commodity.info.name, 'split');
    return imageList.map((i, ik) => (
      <div className={styles.item} key={ik}>
        <div
          className={styles.thumb}
          style={{
            backgroundImage: `url(${i.customer_image_url})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <div className={styles.info}>
          <p className={styles.pName}>{name}</p>
          {!hasSameName ? <p className={styles.cName}>{commodity.info.name}</p> : null}
          <p className={styles.count}>× {count}</p>
        </div>
      </div>
    ));
  })
);

export default CustomSkinItem;
